import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import * as _ from 'underscore';
import { Override } from '../../../app-decorators';

@Injectable()
export class ChangeBpPreconditionService extends BaseReportActionsHandler {

  @Override(BaseReportActionsHandler)
  public execute(): Promise<string | void> {
    if (this.inactiveBPInWebshop()) {
      return Promise.reject('Please select only rows where BP is active in webshop');
    }

    return Promise.resolve();
  }

  private inactiveBPInWebshop(): boolean {
    const listInactiveBPsInWebshops: string[] = [];

    _.each(this.rowSelection, (row:any) => {
      if(!_.isEmpty(row.Deinact_ds)){
        listInactiveBPsInWebshops.push(row.Deinact_ds);
      }
    });

    return !!listInactiveBPsInWebshops.length;
  }
}